/**
 * Contract Types Catalog Hook
 */

import { useState, useEffect } from 'react';
import { contractCatalogService } from '../contract.service.ts';
import type { ContractType } from '../contract.types.ts';


interface UseContractTypesResult {
  types: ContractType[];
  loading: boolean;
  error: string | null;
}

export function useContractTypes(): UseContractTypesResult {
  const [types, setTypes] = useState<ContractType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    void (async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await contractCatalogService.getTypes();

        if (!isMounted) return;

        if (response.success && response.data) {
          setTypes(response.data);
        } else if (response.error) {
          setError(response.error.description || 'Error loading contract types');
        }
      } catch (catchError) {
        if (!isMounted) return;
        setError(catchError instanceof Error ? catchError.message : 'Unknown error');
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return { types, loading, error };
}
